import styles from "./CreateCategoryPopup.module.scss";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { Form, FormInstance } from "antd";
import { IClassCategory } from "../../../models/ClassCategory";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import useAppDispatch from "../../../hooks/useAppDispatch";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { useClassCategoryMutations } from "../../../api/mutations";
import { openSuccessMessage } from "../../../store/message/messageSlice";
import { handleError } from "../../../helper/errorHandler";

interface ICreateCategoryPopupProps {
  closePopup: () => void;
  item: IClassCategory | null;
  getData: () => void;
}

const CreateCategoryPopup: React.FC<ICreateCategoryPopupProps> = ({
  item,
  closePopup,
  getData,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const formRef = useRef<FormInstance>(null);

  const { createCategory, updateCategory } = useClassCategoryMutations();

  useEffect(() => {
    if (formRef.current && item) {
      formRef.current.setFieldsValue({
        name: item.name,
      });
    }
  }, [item, formRef.current]);

  const onFinish = async (values: Omit<IClassCategory, "id">) => {
    const model: Omit<IClassCategory, "id"> = {
      ...values,
    };

    if (item) {
      updateCategory(
        { id: item.id, model },
        {
          onSuccess: () => {
            dispatch(openSuccessMessage(t("CategoryUpdatedSuccessfully")));
            closePopup();
            getData();
          },
          onError: (e) => handleError(e, dispatch, t),
        }
      );
    } else {
      createCategory(model, {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("CategoryCreatedSuccessfully")));
          closePopup();
          getData();
        },
        onError: (e) => handleError(e, dispatch, t),
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <h3 className={styles.title}>{item ? t("EditCategory") : t("AddNewCategory")}</h3>
        <Form
          className={styles.form}
          ref={formRef}
          name="create-category"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <FormItemInput name={"name"} label={t("Name") + " *"} rules={{ required: true }} />

          <div className={styles.btnsWrapper}>
            <CustomButton
              text={t("Close")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={closePopup}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CreateCategoryPopup;
